<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Analytics</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxWidth="full" sxHeight="full" sxOverflow="hidden" sxPadding="medium" sxRow sxAlign="start" sxGap="10px">

    <div sxWidth="fill" sxFlexShrink="0" sxCol sxGap="10px" sxHeight="100%" sxMaxHeight="100%" sxOverflow="scroll">

      <div sxFlexShrink="0" class="ai-wrapper" sxWidth="full" sxRow sxAlign="center" sxDistribution="spaceBetween"
           sxGap="10px" sxPadding="medium" sxRadius="medium">
        <div sxRow sxAlign="center" sxGap="10px">
          <ion-icon name="sparkles"></ion-icon>
          <h1 sxColor="white" sxTextSize="medium" sxMargin="0">AI Insights</h1>
          <p sxMargin="0">Get most out of your customer data</p>
        </div>
        <button (click)="alert('Coming Soon!')">Start Now</button>
      </div>

      <div sxCol sxWidth="full" sxHeight="400px" sxBackground="light" sxRadius="medium" sxPadding="medium">
        <div sxRow sxAlign="end" sxGap="10px">
          <h1>Collections</h1>
          <!--          <p sxColor="two"><span sxColor="success" sxTextWeight="bold">+9%</span> vs last week</p>-->
        </div>
        <div sxWidth="full" sxHeight="fill">
          <canvas id="count-chart-canvas"></canvas>
        </div>

      </div>

      <div sxRow sxGap="10px">
        <div sxCol sxWidth="fill" sxHeight="300px" sxBackground="light" sxRadius="medium" sxPadding="medium">
          <h1>Age</h1>
          <div sxWidth="full" sxHeight="200px">
            <canvas id="age-chart-canvas"></canvas>
          </div>
        </div>
        <div sxCol sxWidth="300px" sxHeight="300px" sxBackground="light" sxRadius="medium" sxPadding="medium">
          <h1>Gender</h1>
          <div sxWidth="full" sxHeight="180px">
            <canvas id="gender-chart-canvas"></canvas>
          </div>
        </div>
      </div>

    </div>

    <div sxMinWidth="350px" sxWidth="20%" sxMaxHeight="100%" sxBackground="base-shade" sxRadius="medium"
         sxPadding="medium">

      <div sxRow sxAlign="center" sxDistribution="spaceBetween" sxBorderWidth="0 0 1px" sxBorderColor="one"
           sxPadding="0 0 medium">
        <h3 sxMargin="0" sxColor="three">Filters</h3>
        <super-button size="v-small" [action]="fetchAnalytics">Apply</super-button>
      </div>

      <h5 sxColor="three">Period</h5>
      <ion-segment [(ngModel)]="selectedRangeOption" mode="ios" (ionChange)="onDateRangeChanged()">
        <ion-segment-button [value]="DateRange.WEEK">
          <ion-label>7-D</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="DateRange.LAST_30_D">
          <ion-label>30-D</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="DateRange.LAST_12_MONTHS">
          <ion-label>Year</ion-label>
        </ion-segment-button>
        <!--        <ion-segment-button [value]="DateRange.CUSTOM">-->
        <!--          <ion-label>Custom</ion-label>-->
        <!--        </ion-segment-button>-->
      </ion-segment>

      <h5 sxColor="three">Forms</h5>
      <template-selector
        [(scannerTemplateOptions)]="templateOptions"
        [isShowSelectAll]="true"
        [(isAllSelected)]="isAllTemplateSelected"></template-selector>


      <div sxMargin="medium 0" *ngIf="(orgRelationship$ | async)?.length > 0" sxPadding="0 10px 0 0" sxBorderColor="one" sxBorderWidth="0 1px 0 0">
        <ion-item>
          <ion-toggle [(ngModel)]="showBranchAccounts" (ionChange)="onBranchesToggled()">Show Branches Data</ion-toggle>
        </ion-item>

      </div>

<!--      <h5 sxColor="three">Accounts</h5>-->


<!--      <div sxCol sxGap="10px" *ngIf="orgRelationship$ | async as relations"-->
<!--      sxBackground="light" sxRadius="medium">-->
<!--        <div *ngFor='let orgRelation of relations' sxPadding='medium'-->
<!--             sxBackground='light'-->
<!--             sxCursor="pointer"-->
<!--             sxRow sxDistribution='start' sxAlign='center' sxGap='10px'>-->
<!--          {{orgRelation?.childOrg?.name}}-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </div>
</ion-content>
